import customerBaseController from "../customer.base.controller";

class ServiceOptionController extends customerBaseController {

	/*@ngInject*/
	constructor(Modal, $stateParams, $translate, $q, Auth, $state, $scope) {
		super(Auth, $state, Modal, $translate, $stateParams, $scope);

		this.unitBasisOptions = [
			{
				label: $translate.instant('common.rolled_coin'),
				key: 'rolled_coin'
			},
			{
				label: $translate.instant('common.loose_coin'),
				key: 'loose_coin'
			},
			{
				label: $translate.instant('common.currency_deposit'),
				key: 'currency_deposit'
			},
			{
				label: $translate.instant('common.transport'),
				key: 'transport'
			},
			{
				label: $translate.instant('common.non_scheduled_transport'),
				key: 'non_scheduled_transport'
			},
			{
				label: $translate.instant('common.stop_time'),
				key: 'stop_time'
			},
			{
				label: $translate.instant('common.excess_stop_time'),
				key: 'excess_stop_time'
			},
			{
				label: $translate.instant('common.ATM_load'),
				key: 'ATM_load'
			},
			{
				label: $translate.instant('common.AMT_count'),
				key: 'AMT_count'
			},
			{
				label: $translate.instant('common.FLM'),
				key: 'FLM'
			},
			{
				label: $translate.instant('common.Misc'),
				key: 'Misc'
			}
		];

		this.unitBasisOptionsChildren = {
			'rolled_coin': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.box'),
				value: 'PER_BOX'
			},
			{
				label: $translate.instant('common.roll'),
				value: 'PER_ROLL'
			},
			{
				label: $translate.instant('common.thousand'),
				value: 'PER_THOUSAND'
			}
			],
			'loose_coin': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.bag'),
				value: 'PER_BAG'
			},
			{
				label: $translate.instant('common.amount'),
				value: 'PER_AMOUNT'
			}
			],
			'currency_deposit': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.bill'),
				value: 'PER_BILL'
			},
			{
				label: $translate.instant('common.thousand'),
				value: 'PER_THOUSAND'
			},
			{
				label: $translate.instant('common.hundred'),
				value: 'PER_HUNDRED'
			},
			{
				label: $translate.instant('customer.deposit'),
				value: 'PER_DEPOSIT'
			}
			],
			'transport': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.trip'),
				value: 'PER_TRIP'
			},
			{
				label: $translate.instant('common.monthlyprebill'),
				value: 'MONTHLY_PREBILL'
			}
			],
			'non_scheduled_transport': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.trip'),
				value: 'PER_TRIP'
			}
			],
			'stop_time': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.minute'),
				value: 'PER_MINUTE'
			},
			{
				label: $translate.instant('common.flat'),
				value: 'FLAT_RATE'
			}
			],
			'excess_stop_time': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.minute'),
				value: 'PER_MINUTE'
			},
			{
				label: $translate.instant('common.flat'),
				value: 'FLAT_RATE'
			}
			],
			'ATM_load': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.load'),
				value: 'PER_LOAD'
			},
			{
				label: $translate.instant('common.flat'),
				value: 'FLAT_MONTHLY'
			}
			],
			'AMT_count': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.count'),
				value: 'PER_COUNT'
			},
			{
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			},
			{
				label: $translate.instant('common.load'),
				value: 'PER_LOAD'
			}
			],
			'FLM': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			},
			{
				label: $translate.instant('common.call'),
				value: 'PER_CALL'
			}
			],
			'Misc': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			},
			{
				label: $translate.instant('common.unit'),
				value: 'PER_UNIT'
			},
			{
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			}
			]
		}

		this.unitBasisModels = {
			'rolled_coin': {
				basis: 'rolledCoinRateBasis',
				rate: 'rolledCoinChargeRate',
				billToCategory: 'rolledCoinBillToCategory'
			},
			'loose_coin': {
				basis: 'looseCoinRateBasis',
				rate: 'looseCoinChargeRate',
				billToCategory: 'looseCoinBillToCategory'
			},
			'currency_deposit': {
				basis: 'currencyDepositRateBasis',
				rate: 'currencyDepositChargeRate',
				billToCategory: 'currencyDepositBillToCategory'
			},
			'transport': {
				basis: 'transportRateBasis',
				rate: 'transportChargeRate',
				billToCategory: 'transportBillToCategory'
			},
			'non_scheduled_transport': {
				basis: 'noScheduledTransportRateBasis',
				rate: 'noScheduledTransportChargeRate',
				billToCategory: 'noScheduledTransportBillToCategory'
			},
			'stop_time': {
				basis: 'stopTimeRateBasis',
				rate: 'stopTimeChargeRate',
				billToCategory: 'stopTimeBillToCategory'
			},
			'excess_stop_time': {
				basis: 'excessStopTimeRateBasis',
				rate: 'excessStopTimeChargeRate',
				billToCategory: 'excessStopTimeBillToCategory',
			},
			'ATM_load': {
				basis: 'atmLoadRateBasis',
				rate: 'atmLoadChargeRate',
				billToCategory: 'atmLoadBillToCategory',
			},
			'AMT_count': {
				basis: 'atmCountRateBasis',
				rate: 'atmCountChargeRate',
				billToCategory: 'atmCountBillToCategory',
			},
			'FLM': {
				basis: 'flmRateBasis',
				rate: 'flmChargeRate',
				billToCategory: 'flmBillToCategory',
			},
			'Misc': {
				basis: 'miscItemRateBasis',
				rate: 'miscItemChargeRate',
				billToCategory: 'miscItemBillToCategory',
			},
		}

		this.serviceOptions = this.unitBasisOptions;

		this.selectedUnitBasisOptions = [];

		this.billToCategoryOptions = [
			{
				label: $translate.instant('contract.changeOrder'),
				value: 'CHANGE_ORDER',
			},
			{
				label: $translate.instant('contract.transport'),
				value: 'TRANSPORT'
			},
			{
				label: $translate.instant('customer.deposit'),
				value: 'DEPOSIT'
			}
		]

		this.DEFAULT_BASIS = null;
		this.DEFAULT_BILL_TO_CATEGORY = null;
	}

	$onInit() {
		this.selectedUnitBasisOptions = this.getUnitBasisOptions();
	}

	removeUnitBasisOption(index) {
		let serviceToRemove = this.selectedUnitBasisOptions[index]
		let models = (serviceToRemove.serviceName && serviceToRemove.serviceName.key) ? this.unitBasisModels[serviceToRemove.serviceName.key] : null;

		if (models) {
			this.model[models.basis] = null;
			this.model[models.rate] = null;
			this.model[models.billToCategory] = null;
		}
		this.selectedUnitBasisOptions.splice(index, 1);
	}

	isNoneSelected(unitBasisOption) {
		return this.model[unitBasisOption.models.basis] === 'NONE';
	}

	addUnitBasisOption() {
		this.selectedUnitBasisOptions.push({
			serviceName: null,
			options: null,
			models: null
		});
	}

	// checkForDuplicates(unitBasisOption, index){
	// 	var found = false;
	// 	this.selectedUnitBasisOptions.forEach(function(opt, idx){
	// 		if(index != idx &&
	// 			unitBasisOption.serviceName === opt.serviceName &&
	// 			unitBasisOption.basis === opt.basis &&
	// 			unitBasisOption.billToCategory === opt.billToCategory){
	// 				found = true;	
	// 			}
	// 	});

	// 	if(found) {
	// 		unitBasisOption.duplicate = true;
	// 	}else{
	// 		unitBasisOption.duplicate = false;
	// 	}
	// }

	unitBasisOptionChanged(unitBasisOption, index) {		
		let oldItems = this.getUnitBasisOptions();
		let selectedService = unitBasisOption.serviceName.key
		unitBasisOption.options = this.unitBasisOptionsChildren[selectedService];
		unitBasisOption.models = this.unitBasisModels[selectedService];

		if (!this.model[unitBasisOption.models.basis]) {
			this.model[unitBasisOption.models.basis] = this.DEFAULT_BASIS;
		}
		if (!this.model[unitBasisOption.models.billToCategory]) {
			this.model[unitBasisOption.models.billToCategory] = this.DEFAULT_BILL_TO_CATEGORY;
		}
		if (!this.model[unitBasisOption.models.rate]) {
			this.model[unitBasisOption.models.rate] = null;
		}

		if (oldItems[index] && oldItems[index].serviceName.key !== unitBasisOption.serviceName.key) {
			this.model[oldItems[index].models.basis] = null;
			this.model[oldItems[index].models.billToCategory] = null;
			this.model[oldItems[index].models.rate] = null;
		}
	};

	getUnitBasisOptions() {
		let unitBasisOptions = [];
		let billToCategoryOptions = [];
		this.serviceOptions.forEach((serviceName, index) => {
			let models = this.unitBasisModels[serviceName.key];
			
			if ((this.model[models.basis] && this.model[models.basis] !== 'NONE') || this.model[models.rate] ||  this.model[models.billToCategory]) {
				unitBasisOptions.push({
					serviceName: serviceName,
					options: this.unitBasisOptionsChildren[serviceName.key],
					models: this.unitBasisModels[serviceName.key],

				});
			}
			else {
				this.model[models.basis] = null;
				this.model[models.rate] = null;
				this.model[models.billToCategory] = null;
			}
		})

		return unitBasisOptions;
	}
}

export default ServiceOptionController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/common/service_options/service_option.controller.js